import { render, staticRenderFns } from "./DidsLogin.vue?vue&type=template&id=f9c83e10&scoped=true&"
import script from "./DidsLogin.vue?vue&type=script&lang=js&"
export * from "./DidsLogin.vue?vue&type=script&lang=js&"
import style0 from "./DidsLogin.vue?vue&type=style&index=0&id=f9c83e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c83e10",
  null
  
)

export default component.exports